package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.model.AudioData
import fr.manyverse.app.domain.model.Sound
import fr.manyverse.app.domain.model.SoundTag
import fr.manyverse.app.domain.model.SoundType
import fr.manyverse.app.domain.repository.SoundRepository
import fr.manyverse.app.domain.validation.AudioValidator

/**
 * Use case for uploading a new sound.
 * Validates the audio data and name before uploading.
 */
class UploadSoundUseCase(
    private val soundRepository: SoundRepository
) {
    /**
     * Uploads a new sound.
     * @param userId The ID of the user uploading the sound
     * @param universeId The universe the sound belongs to
     * @param name The display name of the sound
     * @param type The type of sound (MUSIC or EFFECT)
     * @param tags The tags associated with the sound
     * @param audioData The audio file data
     * @return Result containing the created Sound
     */
    suspend operator fun invoke(
        userId: String,
        universeId: String,
        name: String,
        type: SoundType,
        tags: Set<SoundTag>,
        audioData: AudioData
    ): Result<Sound> {
        // Validate audio data first
        AudioValidator.validate(audioData).onFailure {
            return Result.failure(it)
        }

        // Validate name
        AudioValidator.validateName(name).onFailure {
            return Result.failure(it)
        }

        return soundRepository.uploadSound(
            userId = userId,
            universeId = universeId,
            name = name.trim(),
            type = type,
            tags = tags,
            audioData = audioData
        )
    }
}
